import axios from "axios";
import { appConfig } from "../enviroments/enviroment";
import {
  append_to_dom,
  catch_error,
  get_user_info,
  set_user_data,
} from "../firebase/functions";

let cooked_recipes = [];
let post_id = "";
let submissionDate = "";
let display_faves = "";
let display_cooked = "";
let faves_margin = "";
let cooked_recipes_count = 0;
let can_update_uder_data = false;

jQuery(document).ready(function ($) {
  if (JSON.parse(localStorage.getItem("user_info"))?.cooked) {
    let looped_cooked_recipes = JSON.parse(
      localStorage.getItem("user_info")
    )?.cooked;

    for (let i in looped_cooked_recipes) {
      for (let j = 0; j < looped_cooked_recipes[i].length; j++) {
        cooked_recipes_count++;
        cooked_recipes.push(looped_cooked_recipes[i][j]);
        if (!looped_cooked_recipes[i][j].isApproved) {
          can_update_uder_data = true;
        }
      }
    }

    if (cooked_recipes_count !== 0) {
      $("#my_cooked_recipes_count").css("display", "block");
      $("#my_cooked_recipes_count").text(cooked_recipes_count);
      $(".cooked_span").css("display", "block");
      $(".cooked_span").text(` (${cooked_recipes_count}) `);
    }
  }

  if (window.location.pathname == "/profile/my-cooked-recipes") {
    async function list_cooked_recipes(recipes) {
      if (window.location.pathname.includes("my-cooked-recipes")) {
        if ($("#my_cookced_recipes_list")) {
          if (recipes.length > 0) {
            for (let i = 0; i < recipes.length; i++) {
              let id = recipes[i].postID;
              let cookedSubmissionDate = recipes[i].submissionDate;
              let data = `&action=get_cookbook_info&cookbook_post_id=${id}&cooked_submission_date=${cookedSubmissionDate}`;
              console.log("here");
              $.ajax({
                type: "POST",
                dataType: "html",
                url: show_cookbook_info.ajaxurl,
                data: data,
                success: (res) => {
                  $("#my-cookbooks-loading").remove();
                  let item = JSON.parse(res).item;
                  if (item && item.title) {
                    $("#my_cookced_recipes_list").append(
                      render_recipe(
                        item.title,
                        item.excerpt,
                        item.image,
                        item.category,
                        item.post_faves,
                        item.post_cooked,
                        item.url,
                        i,
                        item.id,
                        item.submissionDate,
                        recipes[i].isApproved
                          ? recipes[i].isApproved
                          : item.isApproved
                      )
                    );
                  }
                },
                error: (err) => {
                  catch_error(err);
                },
              });
            }
          } else {
            $("#my-cookbooks-loading").remove();
            $("#my_cookced_recipes_list").append(
              "<h2>لم تقم بطبخ أي وصفة.</h2>"
            );
          }
        }
      }
    }

    if (can_update_uder_data) {
      set_user_data()
        .then(() => {
          list_cooked_recipes(cooked_recipes);
        })
        .catch((err) => {
          list_cooked_recipes(cooked_recipes);
          catch_error(err);
        });
    } else {
      list_cooked_recipes(cooked_recipes);
    }

    function render_recipe(
      name,
      excerpt,
      image,
      category,
      faves,
      cooked,
      url,
      i,
      id,
      date,
      isApproved
    ) {
      display_faves = "none";
      display_cooked = "none";
      faves_margin = "4.4rem";

      if (faves !== "" && faves !== 0) {
        display_faves = "block";
      }

      if (cooked !== "" && cooked !== 0) {
        display_cooked = "block";
      } else {
        faves_margin = "0";
      }

      let delete_name = name.split(" ").join("_");

      let template = `<div class="grid__col grid__col--1of2" id="cooked_recipe_${id}">
    <div class="article article--medium cooked__recipes__item">
      <a style="z-index:unset;" href="${url}"></a>
      <div class="article__inner">
        <div class="article__media">
          <div class="article__image" style="background-image: url(${image});">
            <label class="label-xs">${category}</label>
            <div class="article__overlay">`;

      if (!isApproved) {
        template += `<a id="edit_cooked_recipe" data-id=${id}>
              <img src="/content/themes/atyabtabkha/src/assets/images/svg/ico-edit.svg">
                </a>`;
      }

      template += ` <a id="delete_cooked_recipe" data-delete-id=${id} data-delete-date=${date} data-delete-name="${delete_name}">

            <img src="/content/themes/atyabtabkha/src/assets/images/svg/ico-remove.svg">

            </a>
            </div><!-- /.article__overlay -->
          </div><!-- /.article__image -->
        </div><!-- /.article__media -->
        <div class="article__content">
          <h6 class="excerpt-description-two" style="-webkit-box-orient: vertical;word-break: break-word;">${name}</h6>
          <p class="excerpt-description" style="-webkit-box-orient: vertical;">${excerpt}</p>
        </div><!-- /.article__content -->
      </div><!-- /.article__inner -->
      <div class="article__actions">
        <ul>
          <li style="display:${display_cooked}">
            <a class="js-link" data-target="#popup-story">
            <img src="/content/themes/atyabtabkha/src/assets/images/svg/link-img-1.svg">
              ${cooked}
            </a>
          </li>
          <li style="display:${display_faves};margin-right:${faves_margin};">
            <a class="js-link" data-target="#popup-story">
            <img src="/content/themes/atyabtabkha/src/assets/images/svg/link-img-3.svg">

              ${faves}
            </a>
          </li>
        </ul>
      </div><!-- /.article__actions -->
    </div>
  </div>`;

      return template;
    }

    function remove_from_cooked() {
      $("#delete_cooked_recipe_confirm #recipe_delete_confirm").addClass(
        "button--loading"
      );
      let new_count =
        parseInt($(".cooked_span").text().split("(")[1].split(")")[0]) - 1;
      const url = `${appConfig.API.URL}/cookedBy`;
      let access_token = JSON.parse(
        localStorage.getItem("login_result")
      )?.access_token;

      let body = {
        action: "remove",
        postID: post_id,
        userID: JSON.parse(localStorage.getItem("user")).uid,
        submissionDate: submissionDate,
      };
      axios
        .post(url, body, {
          headers: {
            "x-api-key": appConfig.API.KEY,
            Authorization: ` Bearer ${access_token}`,
          },
        })
        .then((res) => {
          $("#delete_cooked_recipe_confirm").remove();
          $(`#cooked_recipe_${post_id}`).remove();
          $(".cooked_span").text(`(${new_count})`);

          get_user_info(false, false, true);
          post_id = "";
          submissionDate = "";
        })
        .then(() => {
          if (localStorage.getItem("user_info")) {
            if (JSON.parse(localStorage.getItem("user_info"))) {
              if (
                Object.values(
                  JSON.parse(localStorage.getItem("user_info")).cooked
                )
              ) {
                if (
                  Object.values(
                    JSON.parse(localStorage.getItem("user_info")).cooked
                  ).length !== 0
                ) {
                  $(".cooked_span").css("display", "none");
                }
              }
            }
          }
        })
        .catch((err) => {
          $("#delete_cooked_recipe_confirm #recipe_delete_confirm").removeClass(
            "button--loading"
          );
          catch_error(err);
        });
    }

    $(document).on("click", "#delete_cooked_recipe", function () {
      post_id = $(this).data("delete-id");
      submissionDate = $(this).data("delete-date");
      append_to_dom(
        "popup-remove-from-cooked-open",
        "delete_cooked_recipe_confirm",
        null
      );
    });

    $(document).on(
      "click",
      "#delete_cooked_recipe_confirm #recipe_delete_confirm",
      function () {
        remove_from_cooked();
      }
    );

    $(document).on(
      "click",
      "#delete_cooked_recipe_confirm #recipe_delete_cancel",
      function () {
        post_id = "";
        submissionDate = "";
        $("#delete_cooked_recipe_confirm").remove();
      }
    );
  }
});
